jQuery(document).ready(function ($) {

    // Toggle main mobile menu
    $(".menu_open").click(function () {
        $(".mobile_menu_wrap").toggleClass("menu_show");
        $(".menu_overlay").toggle();
        $("html").toggleClass("overflow-hidden");
        $(".menu_open .bi-list").toggleClass("bi-x");
    });

    // Close menu on overlay click or close button
    $(".menu_close, .menu_overlay, .mobile_menu_wrap ul li a").click(function () {
        closeAllMenus();
    });

    // Add submenu toggle button to parent items
    $(".mobile_menu_wrap ul li:has(ul)").addClass("hassub").append(
        '<a href="javascript:;" class="sub_menu_open"><i class="bi bi-plus"></i></a>'
    );

    // Add back button to submenus
    $(".mobile_menu_wrap ul li ul").append(
        '<li class="back_to_mainmenu"><a href="javascript:;"><i class="bi bi-chevron-left"></i> Back</a></li>'
    );

    // Prevent default action on placeholder links
    $("li.hassub a[href='#'], li.hassub a[href='javascript:;'], li.hassub a[href='javascript:void(0);']").addClass("no_link");

    // Handle submenu open/close via arrow icon
    $(".mobile_menu_wrap").on('click', 'ul li a.no_link', function (e) {
        e.preventDefault();
        const $submenu = $(this).next('ul');
        $(".menu_open .bi-list").removeClass("bi-x");

        if ($submenu.length) {
            if ($submenu.hasClass("show_submenu")) {
                closeSubmenuAndChildren($submenu);
            } else {
                openSubmenu($submenu);
            }
        }
    });

    // Handle back button inside submenu
    $(".mobile_menu_wrap").on('click', '.back_to_mainmenu', function () {
        const $submenu = $(this).parent();
        closeSubmenuAndChildren($submenu);
    });

    // Handle submenu toggle from .sub_menu_open link
    $(".mobile_menu_wrap").on('click', '.sub_menu_open', function (e) {
        e.preventDefault();
        const $submenu = $(this).prev("ul");
        const $icon = $(this).find(".bi");

        if ($submenu.hasClass("show_submenu")) {
            closeSubmenuAndChildren($submenu);
        } else {
            openSubmenu($submenu);
        }
    });

    // Helper functions
    function closeAllMenus() {
        $(".mobile_menu_wrap").removeClass("menu_show");
        $(".menu_overlay").hide();
        $(".mobile_menu_wrap ul li ul").removeClass("show_submenu");
        $("html").removeClass("overflow-hidden");
        $(".sub_menu_open .bi").removeClass("bi-dash").addClass("bi-plus");
    }

    function openSubmenu($submenu) {
        $submenu.addClass("show_submenu");
        $submenu.siblings('.sub_menu_open').find('.bi')
            .removeClass('bi-plus')
            .addClass('bi-dash');
    }

    function closeSubmenuAndChildren($submenu) {
        // Close this submenu and all nested submenus
        $submenu.removeClass("show_submenu");
        $submenu.find('ul.show_submenu').removeClass("show_submenu");
        
        // Update icons for this submenu and all nested submenus
        $submenu.find('.sub_menu_open .bi')
            .removeClass('bi-dash')
            .addClass('bi-plus');
        
        // Update icon for this specific submenu
        $submenu.siblings('.sub_menu_open').find('.bi')
            .removeClass('bi-dash')
            .addClass('bi-plus');
    }

});